import IWarningKey from '../../Models/Warning.model';
import { NeoState } from '../Reducers.interface';

export const selectIsWarningDismissed = (warningKey: IWarningKey) => (state: NeoState) =>
  !!state.user.warnings[warningKey];
